import { render, staticRenderFns } from "./MyCouponSelectList.vue?vue&type=template&id=53fb5800&scoped=true"
import script from "./MyCouponSelectList.vue?vue&type=script&lang=js"
export * from "./MyCouponSelectList.vue?vue&type=script&lang=js"
import style0 from "./MyCouponSelectList.vue?vue&type=style&index=0&id=53fb5800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb5800",
  null
  
)

export default component.exports